import { ReactNode, useState } from "react";
import InputSearch from "components/elements/Input/InputSearch";
import { getModelTextSearch } from "lib/actions/getModelTextSearch";

export default function AutodeskFilteredList<TItem extends object>(p: {
  items: TItem[];
  placeholder: string;
  emptyText: string;
  getKey(item: TItem): string | number;
  getName(item: TItem): string;
  renderItem(item: TItem): ReactNode;
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const { search } = getModelTextSearch(searchTerm, p.getName);
  const matches = search(p.items);

  return (
    <div className="space-y-4">
      <InputSearch
        defaultValue={searchTerm}
        onChange={setSearchTerm}
        placeholder={p.placeholder}
      />
      {matches.length === 0 && (
        <p className="text-center text-sm text-gray-400">
          {searchTerm ? "No matches" : p.emptyText}
        </p>
      )}
      <ul className="space-y-2">
        {matches.map(({ model }) => (
          <li key={p.getKey(model)}>{p.renderItem(model)}</li>
        ))}
      </ul>
    </div>
  );
}
